import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@speedoc/design-assets/build/icons";
import dayjs from "dayjs";
import { wordEllipsis } from "../../utils/strings";
import { useMediaQuery } from "react-responsive";
import { capitalizeWords } from "../../utils/capitalizeWords";
import { slugToCountryPathname } from "../../utils/strings";

export default function NewsCard({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  if (!content) return null;

  let tags = (content?.filterTags || []).map((c, i) => c.tag).join(", ");
  tags = capitalizeWords(tags);

  function getNewsCardContent() {
    return (
      <div className="newsCard">
        <div className="content">
          <div className="top">
            <span className="date">{dayjs(content.publicationDate).format("DD MMMM, YYYY")}</span>
            <Link to={slugToCountryPathname(content.slug)}>
              <h2 className="title">{content.header?.h1}</h2>
            </Link>
            <p className="textBody">{wordEllipsis(content.meta?.seo?.description, 280)}</p>
          </div>
          <div className="bottom">
            <Link to={content.slug} className="buttonLink readMore" arrow="right">
              <span>Read More</span> <ArrowRight className="arrow right" />
            </Link>
            <p className="categories">{tags}</p>
          </div>
        </div>
        <div className="image" style={{ backgroundImage: `url(${content.header?.heroImage?.url})` }}>
          <Link to={slugToCountryPathname(content.slug)} />
        </div>
      </div>
    );
  }

  function getNewsCardContentMobile() {
    return (
      <Link to={slugToCountryPathname(content.slug)}>
        <div className="newsCard">
          <div className="content">
            <div className="top">
              <span className="date">{dayjs(content.publicationDate).format("DD MMMM, YYYY")}</span>
              <h2 className="title">{content.header?.h1}</h2>
              <p className="textBody">{wordEllipsis(content.meta?.seo?.description, 280, 280)}</p>
            </div>
            <div className="bottom">
              <div to={slugToCountryPathname(content.slug)} className="buttonLink readMore" arrow="right">
                <span>Read More</span> <ArrowRight className="arrow right" />
              </div>
              <p className="categories">{tags}</p>
            </div>
          </div>
          <div className="image" style={{ backgroundImage: `url(${content.header?.heroImage?.url})` }} />
        </div>
      </Link>
    );
  }
  return isMobile ? getNewsCardContentMobile() : getNewsCardContent();
}
